/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'GoalLinker.error.generic.description': 'Vérifiez votre connexion Internet et réessayez.',
  'GoalLinker.error.generic.header': 'Une erreur est survenue',
  'GoalLinker.error.linking.header': "Impossible d'associer l'objectif",
  'GoalLinker.error.max-entities-to-goal.description':
    "Vous pouvez associer un maximum de 100 {entities} à un objectif. Veuillez supprimer {entity} si vous souhaitez en associer d'autres.",
  'GoalLinker.error.max-entities-to-goal.header': 'La limite de 100 {entity} est atteinte',
  'GoalLinker.error.max-goals.description':
    "Vous pouvez associer 100 objectifs au maximum. Supprimez des objectifs associés si vous souhaitez en associer d'autres.",
  'GoalLinker.error.max-goals.header': 'La limite de 100 objectifs est atteinte',
  'GoalLinker.goal-row.open-goal': "Ouvrir l'objectif",
  'GoalLinker.link-goals.error-description':
    "Une erreur s'est produite. Vérifiez votre connexion Internet, puis réessayez.",
  'GoalLinker.link-goals.error-title': "Impossible de dissocier l'objectif",
  'GoalLinker.linked-goals.header': 'Objectifs associés',
  'GoalLinker.linked-goals.show-less': 'Afficher moins',
  'GoalLinker.linked-goals.show-more': 'Afficher {count} autre(s)',
  'GoalLinker.recents.emptystate-jira-product-discovery.description':
    'Associez les idées à des objectifs pour suivre la façon dont le travail contribue aux résultats',
  'GoalLinker.recents.emptystate-project.description':
    'Associez vos projets à des objectifs pour suivre la transformation du travail en résultats',
  'GoalLinker.recents.emptystate.description':
    'Associez vos tickets à des objectifs pour suivre la transformation du travail en résultats',
  'GoalLinker.recents.emptystate.header': 'Lancez-vous avec les objectifs',
  'GoalLinker.recents.header': 'Objectifs récents',
  'GoalLinker.search.emptystate.description': "Vérifiez s'il y a des fautes de frappe",
  'GoalLinker.search.emptystate.header': 'Aucun résultat correspondant',
  'GoalLinker.search.label': 'Résultats',
  'GoalLinker.search.placeholder': 'Recherchez des objectifs ou collez un lien',
};
